import styled from 'styled-components';

import { BodyStandardMedium } from '@xemplo/style-constants';

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const FormLabel = styled.div`
  ${BodyStandardMedium};
`;
